import { render, staticRenderFns } from "./navbar8.vue?vue&type=template&id=6ab5b395&scoped=true"
import script from "./navbar8.vue?vue&type=script&lang=js"
export * from "./navbar8.vue?vue&type=script&lang=js"
import style0 from "./navbar8.vue?vue&type=style&index=0&id=6ab5b395&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab5b395",
  null
  
)

export default component.exports